module.exports = __webpack_public_path__ + "static/img/major_pictgrid17_800x675.ac787e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/major_pictgrid17_800x675.jpg
// module id = 77eL
// module chunks = 0